import React from "react";
import MermaidBlock from "./MermaidBlock";

export function flattenMarkdownChildren(children) {
  return React.Children.toArray(children)
    .map((child) => {
      if (typeof child === "string" || typeof child === "number") {
        return String(child);
      }
      if (React.isValidElement(child) && child.props.children != null) {
        return flattenMarkdownChildren(child.props.children);
      }
      return "";
    })
    .join("");
}

/**
 * Custom elements for react-markdown. Mermaid runs client-side via fenced blocks:
 * ```mermaid
 * sequenceDiagram
 *   ...
 * ```
 */
export const markdownComponents = {
  pre({ children }) {
    const nodes = React.Children.toArray(children);
    if (nodes.length !== 1 || !React.isValidElement(nodes[0])) {
      return <pre>{children}</pre>;
    }
    const code = nodes[0];
    const className = code.props?.className || "";
    if (className.includes("language-mermaid")) {
      const chart = flattenMarkdownChildren(code.props.children);
      return <MermaidBlock chart={chart} />;
    }
    return <pre>{children}</pre>;
  },
};
